import { render, staticRenderFns } from "./subsidyReport.vue?vue&type=template&id=0fac0c41&"
import script from "./subsidyReport.vue?vue&type=script&lang=js&"
export * from "./subsidyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports